import React from "react";
import { Instagram, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { SHOP, WHATSAPP_NUMBER } from "@/lib/api";

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#FDF2F5] to-[#FCE4EC] border-t border-[#F4D8E2] mt-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#F8BBD0] to-[#D81B60] flex items-center justify-center text-white font-serif text-lg">S</div>
            <div>
              <p className="font-serif text-lg text-[#2D0A22]">Sugandhi Flowers</p>
              <p className="text-[10px] uppercase tracking-widest text-[#8E6377]">Handcrafted · Vita</p>
            </div>
          </div>
          <p className="text-sm text-[#8E6377] leading-relaxed">Crochet bouquets & gifts made with love — by {SHOP.owner}.</p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-[#D81B60] font-bold mb-3">Shop</p>
          <ul className="space-y-2 text-sm text-[#2D0A22]">
            <li><Link to="/shop" className="hover:text-[#D81B60]">All Products</Link></li>
            <li><Link to="/shop?category=valentine" className="hover:text-[#D81B60]">Valentine's</Link></li>
            <li><Link to="/shop?category=jumbo" className="hover:text-[#D81B60]">Jumbo Bouquets</Link></li>
            <li><Link to="/shop?category=gifting" className="hover:text-[#D81B60]">Gifting</Link></li>
            <li><Link to="/custom" className="hover:text-[#D81B60]">Custom Bouquet</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-[#D81B60] font-bold mb-3">Company</p>
          <ul className="space-y-2 text-sm text-[#2D0A22]">
            <li><Link to="/about" className="hover:text-[#D81B60]">About Us</Link></li>
            <li><Link to="/gallery" className="hover:text-[#D81B60]">Instagram Gallery</Link></li>
            <li><Link to="/track" className="hover:text-[#D81B60]" data-testid="footer-track-link">Track / Cancel Order</Link></li>
            <li><Link to="/policies" className="hover:text-[#D81B60]" data-testid="footer-policies-link">Refund &amp; Return Policy</Link></li>
            <li><a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="hover:text-[#D81B60]">Contact</a></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-[#D81B60] font-bold mb-3">Reach us</p>
          <ul className="space-y-2 text-sm text-[#2D0A22]">
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5 text-[#D81B60]" /><span>{SHOP.city}, Maharashtra</span></li>
            <li className="flex items-center gap-2"><Phone size={14} className="text-[#D81B60]" /><a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer">+91 93226 30051</a></li>
            <li className="flex items-center gap-2"><Instagram size={14} className="text-[#D81B60]" /><a href={SHOP.instagram} target="_blank" rel="noreferrer">{SHOP.instagramHandle}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#F4D8E2] py-4 text-center text-xs text-[#8E6377]">
        © {new Date().getFullYear()} Sugandhi Flowers · Crafted with 💗 in Vita, Sangli
      </div>
    </footer>
  );
};
